import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/context/AuthContext";
import { captureAttribution } from "@/hooks/useAttribution";
import { initAnalytics, trackEvent, EVENTS } from "@/lib/analytics";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import WhoWeHelp from "@/pages/WhoWeHelp";
import About from "@/pages/About";
import Resources from "@/pages/Resources";
import NeedsAssessment from "@/pages/NeedsAssessment";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Assessment from "@/pages/Assessment";
import CampaignLanding from "@/pages/CampaignLanding";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/Login";
import ForgotPassword from "@/pages/admin/ForgotPassword";
import ResetPassword from "@/pages/admin/ResetPassword";
import Dashboard from "@/pages/admin/Dashboard";
import ProtectedRoute from "@/pages/admin/ProtectedRoute";

import { campaigns } from "@/data/campaigns";

function App() {
  useEffect(() => {
    captureAttribution();
    initAnalytics();
    trackEvent(EVENTS.PAGE_VIEW, { path: window.location.pathname });
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public marketing site */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/who-we-help" element={<WhoWeHelp />} />
            <Route path="/about" element={<About />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/needs-assessment" element={<NeedsAssessment />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            {/* Campaign landing pages (reusable architecture) */}
            {campaigns.map((c) => (
              <Route key={c.slug} path={`/${c.slug}`} element={<CampaignLanding slug={c.slug} />} />
            ))}
          </Route>

          {/* Assessment (own focused layout, still within site chrome) */}
          <Route element={<Layout />}>
            <Route path="/assessment" element={<Assessment />} />
          </Route>

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Layout />}>
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </AuthProvider>
  );
}

export default App;
